import { render, staticRenderFns } from "./StockSplitFormModal.vue?vue&type=template&id=7485348c&scoped=true"
import script from "./StockSplitFormModal.vue?vue&type=script&lang=js"
export * from "./StockSplitFormModal.vue?vue&type=script&lang=js"
import style0 from "./StockSplitFormModal.vue?vue&type=style&index=0&id=7485348c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7485348c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7485348c')) {
      api.createRecord('7485348c', component.options)
    } else {
      api.reload('7485348c', component.options)
    }
    module.hot.accept("./StockSplitFormModal.vue?vue&type=template&id=7485348c&scoped=true", function () {
      api.rerender('7485348c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stock/StockSplitFormModal.vue"
export default component.exports